<template>
  <Layout>
    <loading-flux :value="loading"></loading-flux>
    <div class="login-container mx-auto d-block">
      <div class="row justify-content-center ">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft bg-primary">
              <div class="row">
                <div class="col-7">
                  <div class="p-4" style="color:#fff">
                    <h5 class="" style="color:#fff">Bienvenid@!!!</h5>
                    <p class="font-size-14">
                      Ingresa los datos para continuar.
                    </p>
                  </div>
                </div>
                <div class="col-5 align-self-center">
                  <img src="@/assets/images/logo-light.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <span>
                  <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                      <img src="@/assets/images/logo-icon.png" alt height="34" />
                    </span>
                  </div>
                </span>
              </div>
              <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{
                authError
              }}</b-alert>
              <div v-if="notification.message" :class="'alert ' + notification.type">
                {{ notification.message }}
              </div>

              <b-form class="p-2" @submit.prevent="tryToLogIn">
                <b-form-group
                  class="mb-3"
                  id="input-group-1"
                  label="Email"
                  label-for="input-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="email"
                    type="text"
                    placeholder="Ingresar Email"
                    :class="{
                      'is-invalid': submitted && $v.email.$error
                    }"
                  ></b-form-input>
                  <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                    <span v-if="!$v.email.required">Email requerido.</span>
                    <span v-if="!$v.email.email">Ingresa un email valido.</span>
                  </div>
                </b-form-group>

                <b-form-group
                  class="mb-3"
                  id="input-group-2"
                  label="Contraseña"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="password"
                    type="password"
                    placeholder="Ingresar Contraseña"
                    :class="{
                      'is-invalid': submitted && $v.password.$error
                    }"
                  ></b-form-input>
                  <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                    Contraseña Requerida.
                  </div>
                </b-form-group>
                <!-- <b-form-checkbox
                                    class="form-check"
                                    id="customControlInline"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                >
                                    Recordarme
                                </b-form-checkbox> -->
                <div class="mt-3 d-grid">
                  <b-button type="submit" variant="primary" class="btn-block"
                    >Iniciar Sesión</b-button
                  >
                </div>
                <div class="mt-4 text-center">
                  <h5 class="font-size-14 mb-3">Inicia sesión con</h5>

                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a
                        @click="AuthProvider('google')"
                        href="javascript: void(0);"
                        class="social-list-item bg-danger text-white border-danger"
                      >
                        <i class="mdi mdi-google"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="mt-4 text-center">
                  <router-link to="/forgot-password" class="text-muted">
                    <i class="mdi mdi-lock me-1"></i> Olvidaste tu contraseña?
                  </router-link>
                </div>

                <div class="alert alert-primary" v-if="enviroment == 'development'">
                  <strong>ENTORNO DESARROLLO</strong>
                </div>
              </b-form>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <!-- <div class="mt-5 text-center">
                        <p>
                            Don't have an account ?
                            <router-link
                                to="/register"
                                class="fw-medium text-primary"
                                >Signup now</router-link
                            >
                        </p>
                        <p>
                            © {{ new Date().getFullYear() }} Skote. Crafted with
                            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
                        </p>
                    </div> -->
          <!-- end row -->
        </div>
        <!-- end col -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<script>
import axios from 'axios'

import Layout from '../../layouts/auth'
import {
  authMethods,
  // authFackMethods,
  notificationMethods
} from '@/state/helpers'
import { mapState } from 'vuex'

import appConfig from '@/app.config'
import { required, email } from 'vuelidate/lib/validators'

/**
 * Login component
 */
export default {
  page: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: appConfig.description
      }
    ]
  },
  components: {
    Layout
  },
  data() {
    return {
      loading: false,
      email: '',
      password: '',
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  computed: {
    ...mapState('authfack', ['status']),
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
    enviroment() {
      return process.env.NODE_ENV
    }
  },
  methods: {
    ...authMethods,
    // ...authFackMethods,
    ...notificationMethods,
    AuthProvider(provider) {
      this.$auth.authenticate(provider).then((response) => {
        this.tryingToLogIn = true
        this.authError = null

        this.loginGoogle(response)
          .then((token) => {
            this.tryingToLogIn = false
            this.isAuthError = false
            this.loading = false
          })
          .catch((error) => {
            this.loading = false
            this.tryingToLogIn = false
            this.authError =
              'Ha ocurrido un error, verifique el email y la contraseña, si el problema persiste, comuníquese con el administrador'
            this.isAuthError = true
          })
      })
    },
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.loading = true
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.loading = false
        return
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
          this.tryingToLogIn = true
          // Reset the authError if it existed.
          this.authError = null
          return (
            this.logIn({
              email: this.email,
              password: this.password
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false
                this.isAuthError = false
                // Redirect to the originally requested page, or to the home page
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: 'default'
                  }
                )
              })
              .catch((error) => {
                this.tryingToLogIn = false
                this.authError = error ? error : ''
                this.isAuthError = true
              })
          )
        } else if (process.env.VUE_APP_DEFAULT_AUTH === 'fakebackend') {
          const { email, password } = this
          if (email && password) {
            this.login({
              email,
              password
            })
          }
        } else if (process.env.VUE_APP_DEFAULT_AUTH === 'authapi') {
          this.tryingToLogIn = true
          this.authError = null

          if (!window.navigator.onLine) {
            this.loading = false
            this.tryingToLogIn = false
            this.authError = 'No se ha detectado conexión a internet, intente más tarde'
            this.isAuthError = true
            return
          }

          return (
            this.login({
              email: this.email,
              password: this.password
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false
                this.isAuthError = false
                this.loading = false
              })
              .catch((error) => {
                this.loading = false
                this.tryingToLogIn = false
                this.authError =
                  'Ha ocurrido un error, verifique el email y la contraseña, si el problema persiste, comuníquese con el administrador'
                this.isAuthError = true
              })
          )

          // const { email, password } = this;
          // this.login({
          //     email,
          //     password,
          //   });
          //   this.loading = false
        }
      }
    }
  },
  mounted() {
    console.log('Entorno desplegado')
    this.logout()
  }
}
</script>
<style scoped>
.login-container {
  width: 920px;
}

@media (max-width: 959px) {
  .login-container {
    width: 460px;
  }
}
@media (max-width: 480px) {
  .login-container {
    width: 100%;
  }
}
.bg-soft {
  background: url('https://proyecto.fluxsolar.cl/imagenes/bg01d.jpg') no-repeat center center;
  background-size: 100% 100%;
}
</style>
<style>
.panel-ingreso-inspector {
  background: #ffa239;
  padding: 20px;
  color: #fff;
  font-size: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
  font-weight: 500;
  /* font-size: 14px;
    background: transparent;
    text-align: center; */
}

.panel-ingreso-inspector a {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
}
</style>
